/* EMSOIR — Türkiye 81 il + ilçe ARAMALI seçim (kapıda ödeme formu için).
   30-55 yaş / teknolojiden uzak kitle: yaz -> daralan liste -> YEŞİL öneri -> DOKUN.
   İl seçilince ilçe aktifleşir; ilçe o ilin ilçelerinden aramayla seçilir.
   Bağımsız vanilla JS; mevcut form akışını/gönderimini BOZMAZ (input name=il / name=ilce korunur). */
(function () {
  "use strict";
  if (window.__EMIL_INIT) return; // ayni asset iki yerde yuklenirse tek sefer calis
  window.__EMIL_INIT = 1;
  // il: "ilçeler virgülle". (Merkez ilçeler dahil.)
  var IL = {
    "Adana": "Aladağ,Ceyhan,Çukurova,Feke,İmamoğlu,Karaisalı,Karataş,Kozan,Pozantı,Saimbeyli,Sarıçam,Seyhan,Tufanbeyli,Yumurtalık,Yüreğir",
    "Adıyaman": "Besni,Çelikhan,Gerger,Gölbaşı,Kâhta,Merkez,Samsat,Sincik,Tut",
    "Afyonkarahisar": "Başmakçı,Bayat,Bolvadin,Çay,Çobanlar,Dazkırı,Dinar,Emirdağ,Evciler,Hocalar,İhsaniye,İscehisar,Kızılören,Merkez,Sandıklı,Sinanpaşa,Sultandağı,Şuhut",
    "Ağrı": "Diyadin,Doğubayazıt,Eleşkirt,Hamur,Merkez,Patnos,Taşlıçay,Tutak",
    "Aksaray": "Ağaçören,Eskil,Gülağaç,Güzelyurt,Merkez,Ortaköy,Sarıyahşi,Sultanhanı",
    "Amasya": "Göynücek,Gümüşhacıköy,Hamamözü,Merkez,Merzifon,Suluova,Taşova",
    "Ankara": "Akyurt,Altındağ,Ayaş,Bala,Beypazarı,Çamlıdere,Çankaya,Çubuk,Elmadağ,Etimesgut,Evren,Gölbaşı,Güdül,Haymana,Kahramankazan,Kalecik,Keçiören,Kızılcahamam,Mamak,Nallıhan,Polatlı,Pursaklar,Sincan,Şereflikoçhisar,Yenimahalle",
    "Antalya": "Akseki,Aksu,Alanya,Demre,Döşemealtı,Elmalı,Finike,Gazipaşa,Gündoğmuş,İbradı,Kaş,Kemer,Kepez,Konyaaltı,Korkuteli,Kumluca,Manavgat,Muratpaşa,Serik",
    "Ardahan": "Çıldır,Damal,Göle,Hanak,Merkez,Posof",
    "Artvin": "Ardanuç,Arhavi,Borçka,Hopa,Kemalpaşa,Merkez,Murgul,Şavşat,Yusufeli",
    "Aydın": "Bozdoğan,Buharkent,Çine,Didim,Efeler,Germencik,İncirliova,Karacasu,Karpuzlu,Koçarlı,Kuşadası,Kuyucak,Nazilli,Söke,Sultanhisar,Yenipazar",
    "Balıkesir": "Altıeylül,Ayvalık,Balya,Bandırma,Bigadiç,Burhaniye,Dursunbey,Edremit,Erdek,Gömeç,Gönen,Havran,İvrindi,Karesi,Kepsut,Manyas,Marmara,Savaştepe,Sındırgı,Susurluk",
    "Bartın": "Amasra,Kurucaşile,Merkez,Ulus",
    "Batman": "Beşiri,Gercüş,Hasankeyf,Kozluk,Merkez,Sason",
    "Bayburt": "Aydıntepe,Demirözü,Merkez",
    "Bilecik": "Bozüyük,Gölpazarı,İnhisar,Merkez,Osmaneli,Pazaryeri,Söğüt,Yenipazar",
    "Bingöl": "Adaklı,Genç,Karlıova,Kiğı,Merkez,Solhan,Yayladere,Yedisu",
    "Bitlis": "Adilcevaz,Ahlat,Güroymak,Hizan,Merkez,Mutki,Tatvan",
    "Bolu": "Dörtdivan,Gerede,Göynük,Kıbrıscık,Mengen,Merkez,Mudurnu,Seben,Yeniçağa",
    "Burdur": "Ağlasun,Altınyayla,Bucak,Çavdır,Çeltikçi,Gölhisar,Karamanlı,Kemer,Merkez,Tefenni,Yeşilova",
    "Bursa": "Büyükorhan,Gemlik,Gürsu,Harmancık,İnegöl,İznik,Karacabey,Keles,Kestel,Mudanya,Mustafakemalpaşa,Nilüfer,Orhaneli,Orhangazi,Osmangazi,Yenişehir,Yıldırım",
    "Çanakkale": "Ayvacık,Bayramiç,Biga,Bozcaada,Çan,Eceabat,Ezine,Gelibolu,Gökçeada,Lapseki,Merkez,Yenice",
    "Çankırı": "Atkaracalar,Bayramören,Çerkeş,Eldivan,Ilgaz,Kızılırmak,Korgun,Kurşunlu,Merkez,Orta,Şabanözü,Yapraklı",
    "Çorum": "Alaca,Bayat,Boğazkale,Dodurga,İskilip,Kargı,Laçin,Mecitözü,Merkez,Oğuzlar,Ortaköy,Osmancık,Sungurlu,Uğurludağ",
    "Denizli": "Acıpayam,Babadağ,Baklan,Bekilli,Beyağaç,Bozkurt,Buldan,Çal,Çameli,Çardak,Çivril,Güney,Honaz,Kale,Merkezefendi,Pamukkale,Sarayköy,Serinhisar,Tavas",
    "Diyarbakır": "Bağlar,Bismil,Çermik,Çınar,Çüngüş,Dicle,Eğil,Ergani,Hani,Hazro,Kayapınar,Kocaköy,Kulp,Lice,Silvan,Sur,Yenişehir",
    "Düzce": "Akçakoca,Cumayeri,Çilimli,Gölyaka,Gümüşova,Kaynaşlı,Merkez,Yığılca",
    "Edirne": "Enez,Havsa,İpsala,Keşan,Lalapaşa,Meriç,Merkez,Süloğlu,Uzunköprü",
    "Elazığ": "Ağın,Alacakaya,Arıcak,Baskil,Karakoçan,Keban,Kovancılar,Maden,Merkez,Palu,Sivrice",
    "Erzincan": "Çayırlı,İliç,Kemah,Kemaliye,Merkez,Otlukbeli,Refahiye,Tercan,Üzümlü",
    "Erzurum": "Aşkale,Aziziye,Çat,Hınıs,Horasan,İspir,Karaçoban,Karayazı,Köprüköy,Narman,Oltu,Olur,Palandöken,Pasinler,Pazaryolu,Şenkaya,Tekman,Tortum,Uzundere,Yakutiye",
    "Eskişehir": "Alpu,Beylikova,Çifteler,Günyüzü,Han,İnönü,Mahmudiye,Mihalgazi,Mihalıççık,Odunpazarı,Sarıcakaya,Seyitgazi,Sivrihisar,Tepebaşı",
    "Gaziantep": "Araban,İslahiye,Karkamış,Nizip,Nurdağı,Oğuzeli,Şahinbey,Şehitkamil,Yavuzeli",
    "Giresun": "Alucra,Bulancak,Çamoluk,Çanakçı,Dereli,Doğankent,Espiye,Eynesil,Görele,Güce,Keşap,Merkez,Piraziz,Şebinkarahisar,Tirebolu,Yağlıdere",
    "Gümüşhane": "Kelkit,Köse,Kürtün,Merkez,Şiran,Torul",
    "Hakkari": "Çukurca,Derecik,Merkez,Şemdinli,Yüksekova",
    "Hatay": "Altınözü,Antakya,Arsuz,Belen,Defne,Dörtyol,Erzin,Hassa,İskenderun,Kırıkhan,Kumlu,Payas,Reyhanlı,Samandağ,Yayladağı",
    "Iğdır": "Aralık,Karakoyunlu,Merkez,Tuzluca",
    "Isparta": "Aksu,Atabey,Eğirdir,Gelendost,Gönen,Keçiborlu,Merkez,Senirkent,Sütçüler,Şarkikaraağaç,Uluborlu,Yalvaç,Yenişarbademli",
    "İstanbul": "Adalar,Arnavutköy,Ataşehir,Avcılar,Bağcılar,Bahçelievler,Bakırköy,Başakşehir,Bayrampaşa,Beşiktaş,Beykoz,Beylikdüzü,Beyoğlu,Büyükçekmece,Çatalca,Çekmeköy,Esenler,Esenyurt,Eyüpsultan,Fatih,Gaziosmanpaşa,Güngören,Kadıköy,Kağıthane,Kartal,Küçükçekmece,Maltepe,Pendik,Sancaktepe,Sarıyer,Silivri,Sultanbeyli,Sultangazi,Şile,Şişli,Tuzla,Ümraniye,Üsküdar,Zeytinburnu",
    "İzmir": "Aliağa,Balçova,Bayındır,Bayraklı,Bergama,Beydağ,Bornova,Buca,Çeşme,Çiğli,Dikili,Foça,Gaziemir,Güzelbahçe,Karabağlar,Karaburun,Karşıyaka,Kemalpaşa,Kınık,Kiraz,Konak,Menderes,Menemen,Narlıdere,Ödemiş,Seferihisar,Selçuk,Tire,Torbalı,Urla",
    "Kahramanmaraş": "Afşin,Andırın,Çağlayancerit,Dulkadiroğlu,Ekinözü,Elbistan,Göksun,Nurhak,Onikişubat,Pazarcık,Türkoğlu",
    "Karabük": "Eflani,Eskipazar,Merkez,Ovacık,Safranbolu,Yenice",
    "Karaman": "Ayrancı,Başyayla,Ermenek,Kâzımkarabekir,Merkez,Sarıveliler",
    "Kars": "Akyaka,Arpaçay,Digor,Kağızman,Merkez,Sarıkamış,Selim,Susuz",
    "Kastamonu": "Abana,Ağlı,Araç,Azdavay,Bozkurt,Cide,Çatalzeytin,Daday,Devrekani,Doğanyurt,Hanönü,İhsangazi,İnebolu,Küre,Merkez,Pınarbaşı,Seydiler,Şenpazar,Taşköprü,Tosya",
    "Kayseri": "Akkışla,Bünyan,Develi,Felahiye,Hacılar,İncesu,Kocasinan,Melikgazi,Özvatan,Pınarbaşı,Sarıoğlan,Sarız,Talas,Tomarza,Yahyalı,Yeşilhisar",
    "Kırıkkale": "Bahşılı,Balışeyh,Çelebi,Delice,Karakeçili,Keskin,Merkez,Sulakyurt,Yahşihan",
    "Kırklareli": "Babaeski,Demirköy,Kofçaz,Lüleburgaz,Merkez,Pehlivanköy,Pınarhisar,Vize",
    "Kırşehir": "Akçakent,Akpınar,Boztepe,Çiçekdağı,Kaman,Merkez,Mucur",
    "Kilis": "Elbeyli,Merkez,Musabeyli,Polateli",
    "Kocaeli": "Başiskele,Çayırova,Darıca,Derince,Dilovası,Gebze,Gölcük,İzmit,Kandıra,Karamürsel,Kartepe,Körfez",
    "Konya": "Ahırlı,Akören,Akşehir,Altınekin,Beyşehir,Bozkır,Cihanbeyli,Çeltik,Çumra,Derbent,Derebucak,Doğanhisar,Emirgazi,Ereğli,Güneysınır,Hadim,Halkapınar,Hüyük,Ilgın,Kadınhanı,Karapınar,Karatay,Kulu,Meram,Sarayönü,Selçuklu,Seydişehir,Taşkent,Tuzlukçu,Yalıhüyük,Yunak",
    "Kütahya": "Altıntaş,Aslanapa,Çavdarhisar,Domaniç,Dumlupınar,Emet,Gediz,Hisarcık,Merkez,Pazarlar,Simav,Şaphane,Tavşanlı",
    "Malatya": "Akçadağ,Arapgir,Arguvan,Battalgazi,Darende,Doğanşehir,Doğanyol,Hekimhan,Kale,Kuluncak,Pütürge,Yazıhan,Yeşilyurt",
    "Manisa": "Ahmetli,Akhisar,Alaşehir,Demirci,Gölmarmara,Gördes,Kırkağaç,Köprübaşı,Kula,Salihli,Sarıgöl,Saruhanlı,Selendi,Soma,Şehzadeler,Turgutlu,Yunusemre",
    "Mardin": "Artuklu,Dargeçit,Derik,Kızıltepe,Mazıdağı,Midyat,Nusaybin,Ömerli,Savur,Yeşilli",
    "Mersin": "Akdeniz,Anamur,Aydıncık,Bozyazı,Çamlıyayla,Erdemli,Gülnar,Mezitli,Mut,Silifke,Tarsus,Toroslar,Yenişehir",
    "Muğla": "Bodrum,Dalaman,Datça,Fethiye,Kavaklıdere,Köyceğiz,Marmaris,Menteşe,Milas,Ortaca,Seydikemer,Ula,Yatağan",
    "Muş": "Bulanık,Hasköy,Korkut,Malazgirt,Merkez,Varto",
    "Nevşehir": "Acıgöl,Avanos,Derinkuyu,Gülşehir,Hacıbektaş,Kozaklı,Merkez,Ürgüp",
    "Niğde": "Altunhisar,Bor,Çamardı,Çiftlik,Merkez,Ulukışla",
    "Ordu": "Akkuş,Altınordu,Aybastı,Çamaş,Çatalpınar,Çaybaşı,Fatsa,Gölköy,Gülyalı,Gürgentepe,İkizce,Kabadüz,Kabataş,Korgan,Kumru,Mesudiye,Perşembe,Ulubey,Ünye",
    "Osmaniye": "Bahçe,Düziçi,Hasanbeyli,Kadirli,Merkez,Sumbas,Toprakkale",
    "Rize": "Ardeşen,Çamlıhemşin,Çayeli,Derepazarı,Fındıklı,Güneysu,Hemşin,İkizdere,İyidere,Kalkandere,Merkez,Pazar",
    "Sakarya": "Adapazarı,Akyazı,Arifiye,Erenler,Ferizli,Geyve,Hendek,Karapürçek,Karasu,Kaynarca,Kocaali,Pamukova,Sapanca,Serdivan,Söğütlü,Taraklı",
    "Samsun": "Alaçam,Asarcık,Atakum,Ayvacık,Bafra,Canik,Çarşamba,Havza,İlkadım,Kavak,Ladik,Ondokuzmayıs,Salıpazarı,Tekkeköy,Terme,Vezirköprü,Yakakent",
    "Siirt": "Baykan,Eruh,Kurtalan,Merkez,Pervari,Şirvan,Tillo",
    "Sinop": "Ayancık,Boyabat,Dikmen,Durağan,Erfelek,Gerze,Merkez,Saraydüzü,Türkeli",
    "Sivas": "Akıncılar,Altınyayla,Divriği,Doğanşar,Gemerek,Gölova,Gürün,Hafik,İmranlı,Kangal,Koyulhisar,Merkez,Suşehri,Şarkışla,Ulaş,Yıldızeli,Zara",
    "Şanlıurfa": "Akçakale,Birecik,Bozova,Ceylanpınar,Eyyübiye,Haliliye,Harran,Hilvan,Karaköprü,Siverek,Suruç,Viranşehir",
    "Şırnak": "Beytüşşebap,Cizre,Güçlükonak,İdil,Merkez,Silopi,Uludere",
    "Tekirdağ": "Çerkezköy,Çorlu,Ergene,Hayrabolu,Kapaklı,Malkara,Marmaraereğlisi,Muratlı,Saray,Süleymanpaşa,Şarköy",
    "Tokat": "Almus,Artova,Başçiftlik,Erbaa,Merkez,Niksar,Pazar,Reşadiye,Sulusaray,Turhal,Yeşilyurt,Zile",
    "Trabzon": "Akçaabat,Araklı,Arsin,Beşikdüzü,Çarşıbaşı,Çaykara,Dernekpazarı,Düzköy,Hayrat,Köprübaşı,Maçka,Of,Ortahisar,Sürmene,Şalpazarı,Tonya,Vakfıkebir,Yomra",
    "Tunceli": "Çemişgezek,Hozat,Mazgirt,Merkez,Nazımiye,Ovacık,Pertek,Pülümür",
    "Uşak": "Banaz,Eşme,Karahallı,Merkez,Sivaslı,Ulubey",
    "Van": "Bahçesaray,Başkale,Çaldıran,Çatak,Edremit,Erciş,Gevaş,Gürpınar,İpekyolu,Muradiye,Özalp,Saray,Tuşba",
    "Yalova": "Altınova,Armutlu,Çınarcık,Çiftlikköy,Merkez,Termal",
    "Yozgat": "Akdağmadeni,Aydıncık,Boğazlıyan,Çandır,Çayıralan,Çekerek,Kadışehri,Merkez,Saraykent,Sarıkaya,Sorgun,Şefaatli,Yenifakılı,Yerköy",
    "Zonguldak": "Alaplı,Çaycuma,Devrek,Ereğli,Gökçebey,Kilimli,Kozlu,Merkez"
  };

  function trNorm(s) {
    return (s || "").toLocaleLowerCase("tr")
      .replace(/ı/g, "i").replace(/İ/g, "i").replace(/ş/g, "s").replace(/ç/g, "c")
      .replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ö/g, "o").trim();
  }
  var IL_NAMES = Object.keys(IL);

  // Bir input'a arama-öneri davranışı ekler. options: {source: fn()->[names], onPick: fn(name), hint}
  function attach(input, getSource, onPick, hintText) {
    if (!input || input.dataset.emAttached === "1") return;
    input.dataset.emAttached = "1";
    input.setAttribute("autocomplete", "off");
    var box = document.createElement("div");
    box.className = "emil-suggest";
    box.setAttribute("role", "listbox");
    var hint = document.createElement("div");
    hint.className = "emil-hint";
    hint.textContent = hintText || "👆 Listeden dokunarak seçin";
    var wrap = input.parentNode;
    if (wrap && getComputedStyle(wrap).position === "static") wrap.style.position = "relative";
    wrap.appendChild(hint);
    wrap.appendChild(box);

    function render(items) {
      box.innerHTML = "";
      if (!items.length) { box.style.display = "none"; hint.style.display = "none"; return; }
      items.slice(0, 8).forEach(function (name) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "emil-opt";
        b.textContent = name;
        var picked = false;
        function choose(e) {
          if (picked) return; // pointerdown + fallback click iki kez tetiklemesin
          picked = true;
          if (e) { e.preventDefault(); e.stopPropagation(); }
          input.value = name;
          box.style.display = "none"; hint.style.display = "none";
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
          if (onPick) onPick(name);
        }
        // MOBIL FIX (ilçe): secimi dokunusun ILK aninda yap. Onceden secim "click" ile yapiliyordu;
        // mobilde programatik focus + acik klavye + mousedown.preventDefault, click'i geciktirip/yutup
        // deger ancak baska yere dokununca yerlesiyordu. pointerdown/touchstart bunu kesin cozer.
        if (window.PointerEvent) {
          b.addEventListener("pointerdown", choose);
        } else {
          b.addEventListener("touchstart", choose, { passive: false });
          b.addEventListener("click", choose);
        }
        // masaustu/fare: input focus kaybolmasin (pointer yolunda da zararsiz)
        b.addEventListener("mousedown", function (e) { e.preventDefault(); });
        box.appendChild(b);
      });
      box.style.display = "block";
      hint.style.display = "block";
    }
    function update() {
      var q = trNorm(input.value);
      var src = getSource() || [];
      // SECIM TAMAM: deger listede BIREBIR varsa listeyi ACMA. Boylece secince (ozellikle ilce)
      // dispatch edilen 'input' olayi yesil listeyi geri getirmez; il ile ayni davranis.
      if (input.value && src.some(function (n) { return trNorm(n) === q; })) { render([]); return; }
      if (!q) { render(src); return; } // bossa tum liste (kisa)
      var hits = src.filter(function (n) { return trNorm(n).indexOf(q) !== -1; });
      // basta eslesenler once
      hits.sort(function (a, b) {
        var ai = trNorm(a).indexOf(q), bi = trNorm(b).indexOf(q);
        return ai - bi || a.localeCompare(b, "tr");
      });
      render(hits);
    }
    input.addEventListener("input", update);
    input.addEventListener("focus", update);
    input.addEventListener("blur", function () { setTimeout(function () { box.style.display = "none"; hint.style.display = "none"; }, 200); });
  }

  function initScope(scope) {
    var ilInput = scope.querySelector('input[name="il"]:not([data-em-attached="1"])');
    var ilceInput = scope.querySelector('input[name="ilce"]:not([data-em-attached="1"])');
    if (!ilInput) return;
    // İLÇE TEK KAYNAK: ilçe listesi HER ZAMAN il kutusundaki GÜNCEL metnin birebir eşleştiği ilin
    // ilçeleridir. Birebir il eşleşmezse BOŞ (bayat/yanlış ilçe ASLA gösterilmez). "currentIl" fallback
    // KALDIRILDI — müşteri ili yazarak değiştirince eski ilin ilçeleri çıkıyordu (bug 2026-10-01).
    function ilKey() {
      var v = trNorm(ilInput.value.trim());
      if (!v) return "";
      return IL_NAMES.filter(function (n) { return trNorm(n) === v; })[0] || "";
    }
    attach(ilInput, function () { return IL_NAMES; }, function () {
      if (ilceInput) { ilceInput.value = ""; ilceInput.disabled = false; ilceInput.placeholder = "İlçe yazın (örn. Kadıköy)"; ilceInput.focus(); }
    }, "👆 İlinizi yeşil listeden dokunarak seçin");
    if (ilceInput) {
      // İL METNİ DEĞİŞİNCE (yazarak da) ilçeyi SIFIRLA — başka ilin ilçesi formda kalmasın.
      var lastKey = ilKey();
      ilInput.addEventListener("input", function () {
        var k = ilKey();
        if (k !== lastKey) { lastKey = k; ilceInput.value = ""; }
      });
      attach(ilceInput, function () {
        var key = ilKey();
        return key ? (IL[key] || "").split(",") : [];
      }, null, "👆 İlçenizi yeşil listeden dokunarak seçin");
    }
  }

  function boot() {
    document.querySelectorAll("form").forEach(function (f) { initScope(f); });
    // COD modal sonradan DOM'a eklenebilir -> gozlemle
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) {
            if (n.querySelector && n.querySelector('input[name="il"]')) initScope(n);
            if (n.matches && n.matches("form")) initScope(n);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
